module.exports = __webpack_public_path__ + "img/21.1dc63f59.jpg";